import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Company.css"; // Import CSS for modal styling
import { loginUser, registerUser } from "../../api/user";
import { getCompanyByName } from "../../api/add-company";
import HomePage from "./CompanyComponents/HomePage";
import CalculatorPage from "../SolarCalucator";

export type CompanyType = {
  companyName: string;
  user?: any; // Add the user property, adjust the type as needed
  // Add other properties as needed
};

const Company = () => {
  const location = useLocation();

  const companyName = location?.pathname.split("/").pop();

  const [company, setCompany] = useState<CompanyType[]>([]); // State to hold company data
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [username, setUsername] = useState(""); // State for username input
  const [password, setPassword] = useState(""); // State for password input
  const [showInfo, setShowInfo] = useState(false); // State to control info modal visibility
  useEffect(() => {
    if (location.pathname.split("/").includes("admin")) {
      try {
        getCompanyByName(location.pathname.split("/")[2]).then((res) => {
          setCompany(res);
        });
      } catch (error) {
        // console.error("Error fetching company data:", error);
      }
      setShowModal(true); // Show modal if the path includes "admin"
    } else if (location.pathname.split("/")) {
      try {
        getCompanyByName(location.pathname.split("/")[2]).then((res) => {
          setCompany(res);
        });
        setShowInfo(false);
      } catch (error) {
        // console.error("Error fetching company data:", error);
      }
    } else {
      setShowModal(false); // Hide modal otherwise
    }
  }, [companyName, location.pathname]);
  useEffect(() => {
    try {
      const user = localStorage.getItem("userLogged");

      if (user) {
        const parsedUser = JSON.parse(user);
        if (parsedUser) {
          // setShowInfo(true); // Show info modal if user is found in local storage
        }
      }
    } catch (error) {
      // console.error("Error fetching company data:", error);
    }
  }, []);
  const handleRegister = async () => {
    try {
      await registerUser({
        companyName: company[0]?.companyName,
        username,
        password,
      });
      setShowModal(false); // Close the modal after registration
    } catch (error) {
      console.error("Error registering user:", error);
    }
  };

  const handleLogin = async () => {
    // Handle login logic here

    try {
      const res = await loginUser({
        username,
        password,
      });

      if (res.success) {
        localStorage.setItem("userLogged", JSON.stringify(res.success));
        setShowModal(false); // Close the modal after login
        setShowInfo(true); // Show the info modal
      } else {
        alert("Invalid username or password");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      alert("Login failed. Please check your credentials.");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
  };

  return showInfo ? (
    <>
      <HomePage companyInfo={company} />
    </>
  ) : (
    <div>
      <CalculatorPage companyInfo={company} />
      {company?.map((item) => {
        return (
          <div key={item.companyName} className="company-card">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "30vh",
              }}>
              {/* <p
                style={{
                  fontWeight: "bold",
                  fontSize: "2rem",
                  color: "#22223b",
                  background:
                    "linear-gradient(90deg, #a1c4fd 0%, #c2e9fb 100%)",
                  padding: "24px 48px",
                  borderRadius: "16px",
                  boxShadow: "0 4px 24px rgba(44, 62, 80, 0.08)",
                  letterSpacing: "1px",
                  textAlign: "center",
                  marginTop: "-70px",
                }}>
                {item.companyName}
              </p> */}
            </div>
          </div>
        );
      })}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{!company[0]?.user ? "Register User" : "Admin Login"}</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!company[0]?.user) {
                  handleRegister();
                } else {
                  handleLogin();
                }
              }}
              aria-label={
                !company[0]?.user ? "Register User Form" : "Admin Login Form"
              }>
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoComplete="username"
                  aria-required="true"
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete={
                    !company[0]?.user ? "new-password" : "current-password"
                  }
                  aria-required="true"
                  minLength={6}
                />
              </div>
              <button type="submit" className="login-button">
                {!company[0]?.user ? "Register" : "Login"}
              </button>
              <button
                type="button"
                className="close-button"
                onClick={handleCloseModal}>
                Close
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Company;
